import request from '@/utils/axios.js'

export function getSchedule(id, date, type) {
  return request.get(`club/meet/index?activity_id=${id}&meet_date=${date}&type=${type}&t=${new Date().getTime()}`)
}

// 热门议题
export function getHotTopics(data) {
    return request.get(`/club/form/getTopic?form_id=${data.id}&topic_num=${data.pageSize}&ts=${new Date().getTime()}`)
}
// 增加议题权重
export function addTopicScore(data) {
    return request.get(`/club/form/addTopicScore?form_id=${data.id}&topic=${data.text}`)
}
// 增加议题权重
export function addShareNum(id) {
    return request.get(`/club/form/addNum?secret=${id}`)
}
// 获取议题领域列表
export function getConfigList() {
    return request.get(`/portal/index/config?id=UkxGK0tNUnVjL3UxSXRML2F1Q1Y4QT09Ojpn/6F5FaHdcSQ1QUfC0I6f`)
}
// 上传图片
export function uploadImg(file) {
    // 创建一个FormData对象
    const Form = new FormData();
    // 将文件添加到FormData对象中
    Form.append("file", file);
    // 发送POST请求，将FormData对象作为参数
    return request({
        url: `/club/form/uploadImage`,
        method: "POST",
        data: Form,
    });
}
// 提交表单
export function submitForm(data) {
    return request({
        url: `/club/form/add`,
        method: 'POST',
        data: data,
    })
}
// 生成海报
export function getUserImage(data) {
    return request.get(`/club/form/getImage?secret=${data.secret}`)
}